import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {FormBuilder, FormControl} from '@angular/forms';
import {ActivatedRoute} from '@angular/router';
import {setFormValuesFromQueryParams} from '../../../utils/filters-utils';
import {REGIONS} from '../../../../constants/constants';
import {IntelligenceSearchInterface} from '../../../models/intelligence-search.interface';

@Component({
  selector: 'app-systems-in-country-filters',
  templateUrl: './systems-in-country-filters.component.html',
  styleUrls: ['./systems-in-country-filters.component.scss']
})
export class SystemsInCountryFiltersComponent implements OnInit {

  regions = REGIONS;

  searchForm = this.formBuilder.group({
    region: [''],
  });

  get regionControl(): FormControl {
    return this.searchForm.get('region') as FormControl;
  }

  @Output()
  search: EventEmitter<IntelligenceSearchInterface> = new EventEmitter<IntelligenceSearchInterface>();

  constructor(private formBuilder: FormBuilder,
              private activatedRoute: ActivatedRoute) {
  }

  ngOnInit(): void {
    setFormValuesFromQueryParams(this.searchForm, this.activatedRoute);
  }

  handleSubmit(): void {
    this.search.emit({year: 0, region: this.regionControl.value});
  }

  clean(): void {
    this.regionControl.reset();
    this.search.emit();
  }

}
